import type { DiagnosticsResetRequest } from '@prerender/diagnostics-api';

import api from '../../api/apiSlice';

export const resetApi = api.injectEndpoints({
  endpoints: (builder) => ({
    resetDiagnostics: builder.mutation<void, DiagnosticsResetRequest>({
      query: (body) => ({ url: '/diagnostics/resets', method: 'POST', body }),
    }),
  }),
});

export const { useResetDiagnosticsMutation } = resetApi;
